import 'antd-css-utilities/utility.min.css';
import '@/assets/scss/index.scss';
import '@/i18n'; // Initialize i18next before anything else
import { captureException, initSentry } from '@/lib/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { registerModules } from './modules';

initSentry();

/**
 * Initialize application
 * Loads modules before rendering to ensure routes are registered
 */
async function initApp() {
  try {
    // Register modules first (this registers their routes)
    await registerModules();
    console.log('Application initialized with modules');
  } catch (error) {
    console.error('Failed to register modules:', error);
    captureException(error);
    // Continue anyway - app will work with static routes only
  }

  // Render app after modules are loaded
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Start app initialization
initApp();
